<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Lista de Inscriptos
            {{ sistemaCompetencia === "Torneo" ? "del torneo" : "de la liga" }}:
            {{ infoTorneo }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-4">
            <v-col cols="9" sm="5" md="5">
              <v-text-field
                v-model="paciente.dni"
                prepend-icon="mdi-account"
                hint="Ingrese el DNI del jugador y apriete enter o toque fuera de este cuadro de texto. Si el jugador ya existe, se verán sus datos. Si el jugador no existe, deberá buscar un jugador valido para agregar a la lista de inscriptos. Puede también buscar el jugador por apellido y nombre haciendo click en la lupa"
                label="D.N.I"
                dense
                @keypress="onlyNumber"
                @keypress.enter="$event.target.blur()"
                @blur="buscarPacienteDni"
                maxlength="9"
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="2" class="d-flex">
              <v-btn color="primary" @click="buscarPaciente">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.apellidos"
                prepend-icon="mdi-account"
                label="Apellidos"
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.nombres"
                prepend-icon="mdi-account"
                label="Nombres"
                dense
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!paciente.idPaciente"
              @click="inscribir()"
              >Agregar Jugador</v-btn
            >
          </v-card-actions>
        </v-card-text>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-chip class="ma-0" label color="transparent" text-color="black">
                <h3>
                  Jugadores inscriptos en
                  {{
                    sistemaCompetencia === "Torneo" ? "el torneo" : "la liga"
                  }}
                </h3>
              </v-chip>
            </v-col>
          </v-row>

          <v-data-table
            v-if="listaInscriptos.length"
            :headers="headers"
            :items="this.listaInscriptos"
            class="elevation-1"
            locale="es-ar"
            item-key="idCrobro"
            :items-per-page="10"
            ref="myTable"
            :disable-sort="true"
            :footer-props="{
              itemsPerPageText: 'Filas por página',
            }"
          >
            <template v-slot:item.pagado="{ item }">
              <v-simple-checkbox
                v-model="item.pagado"
                disabled
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    medium
                    v-on="on"
                    class="mr-3"
                    color="red"
                    v-bind="attrs"
                    @click="borrarJugador(item)"
                    >mdi-delete</v-icon
                  >
                </template>
                <span>Eliminar jugador inscripto</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    medium
                    class="mr-3"
                    color="#d35400"
                    v-on="on"
                    v-bind="attrs"
                    @click.stop="cobrar(item)"
                    >mdi-currency-usd</v-icon
                  >
                </template>
                <span>Consumos</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <v-alert class="mt-4" color="purple" dark outlined v-else>
            No hay jugadores inscriptos para
            {{ sistemaCompetencia === "Torneo" ? "este torneo" : "esta liga" }}.
          </v-alert>
        </v-card-text>
        <BuscarJugadorTurno
          :visible="showBuscarPaciente"
          @close="showBuscarPaciente = false"
          @seleccionarPaciente="seleccionarPaciente($event)"
        ></BuscarJugadorTurno>
        <ConsumosWrapper
          :visible="showNuevoConsumo"
          :idInscripcion="editedItem.idInscripcion"
          :pacienteTurno="editedItem.nombreJugador"
          :celular="editedItem.celularJugador"
          :nombrePaciente="editedItem.nombreJugador"
          @close="cierraNuevoConsumo"
        ></ConsumosWrapper>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import BuscarJugadorTurno from "@/components/Turnos/BuscarJugadorTurno.vue";
import ConsumosWrapper from "../Consumos/ConsumosWrapper.vue";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    paciente: {
      dni: null,
      apellidos: null,
      nombres: null,
      idPaciente: null,
    },
    showBuscarPaciente: false,
    showNuevoConsumo: false,
    editedItem: {},
    listaInscriptos: [],
    headers: [
      { text: "Jugador", value: "nombreJugador" },
      { text: "Celular", value: "celularJugador" },
      { text: "Acciones", value: "actions" },
    ],
  }),

  props: ["visible", "idTorneo", "infoTorneo", "sistemaCompetencia"],
  components: {
    BuscarJugadorTurno,
    ConsumosWrapper,
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.buscarJugadoresInscriptos();
          return this.visible;
        }
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    cobrar(item) {
      this.editedItem = Object.assign({}, item);
      this.showNuevoConsumo = true;
    },
    cierraNuevoConsumo() {
      this.showNuevoConsumo = false;
    },
    borrarJugador(item) {
      this.$swal({
        title: "Borrar jugador inscripto",
        text: "¿Desea borrar la inscripción del jugador?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            await axios.get("/Torneos/BorrarInscripcion", {
              params: {
                idInscripcion: item.idInscripcion,
              },
            });
            this.showAlert({
              timer: 3200,
              icon: "success",
              title: "Jugador inscripto borrado correctamente.",
              vm: this,
            });
            setTimeout(() => {
              this.buscarJugadoresInscriptos();
            }, 500);
          } catch (error) {
            console.log(error);
            this.showAlert({
              timer: 2200,
              icon: "warning",
              title: "El jugador inscripto no pudo ser borrado.",
              vm: this,
            });
          }
        }
      });
    },
    async buscarJugadoresInscriptos() {
      try {
        const { data: inscriptos } = await axios.get("/Torneos/GetInscriptos", {
          params: {
            idTorneo: this.idTorneo,
          },
        });
        this.listaInscriptos = inscriptos || [];
      } catch (error) {
        console.log(error);
        this.listaInscriptos = [];
      }
    },
    async inscribir() {
      if (
        this.listaInscriptos.some(
          (inscripcion) => inscripcion.idJugador === this.paciente.idPaciente
        )
      ) {
        this.showAlert({
          timer: 3200,
          icon: "warning",
          title: `El jugador ya está inscripto a ${
            this.sistemaCompetencia === "Torneo" ? "éste torneo." : "ésta liga"
          }`,
          vm: this,
        });
        return;
      }

      const datosInscripcion = {
        idTorneo: this.idTorneo,
        idLiga: 0,
        idJugador: this.paciente.idPaciente,
      };
      try {
        await axios.post("/Torneos/InscribirJugador", datosInscripcion);
        this.showAlert({
          timer: 3200,
          icon: "success",
          title: "Jugador inscripto correctamente.",
          vm: this,
        });
        this.vaciarModels();
        setTimeout(() => {
          this.buscarJugadoresInscriptos();
        }, 500);
      } catch (error) {
        this.showAlert({
          timer: 3200,
          icon: "warning",
          title: "El jugador no pudo ser inscripto.",
          vm: this,
        });
      }
    },
    seleccionarPaciente(item) {
      this.paciente.dni = item.nrodocumento;
      this.paciente.apellidos = item.apellidos;
      this.paciente.nombres = item.nombres;
      this.paciente.idPaciente = item.idpaciente;
      this.showBuscarPaciente = false;
    },

    buscarPacienteDni() {
      if (isNaN(this.paciente.dni)) {
        this.showAlert({
          timer: 3200,
          icon: "warning",
          title: "El D.N.I. debe estar compuesto sólo por números.",
          vm: this,
        });
        this.paciente.dni = "";
        this.paciente.idPaciente = 0;
        return;
      }
      if (this.paciente.dni != "" && this.paciente.dni != null)
        this.paciente.dni = parseInt(this.paciente.dni);

      const pacientesData = {
        dni: this.paciente.dni,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Paciente/GetPacienteDniTurno?", {
          params: {
            dni: pacientesData.dni,
            idInstitucion: pacientesData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != "" && response.data != null) {
            self.paciente.apellidos = response.data.apellidos;
            self.paciente.nombres = response.data.nombres;
            self.paciente.idPaciente = response.data.idpaciente;
          } else {
            self.vaciarModels();
            self.paciente.idPaciente = 0;
          }
        })
        .catch(function (error) {});
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    upper() {
      if (this.paciente.apellidos != null)
        this.paciente.apellidos = this.paciente.apellidos
          .toString()
          .toUpperCase();
    },
    upperNombres() {
      if (this.paciente.nombres != null)
        this.paciente.nombres = this.paciente.nombres.toString().toUpperCase();
    },
    buscarPaciente() {
      this.showBuscarPaciente = true;
    },
    vaciarModels() {
      this.paciente.apellidos = "";
      this.paciente.nombres = "";
      this.paciente.idPaciente = null;
      this.paciente.dni = "";
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
